import React from 'react';
import { Button } from '@/components/ui/button';
import { notAvailableYetHint } from '@/lib/notAvailableYet';

// ∑: Variants report header line (FIG-325 / REQ-040, REQ-043, REQ-061): the
// Expected Disposition Cost Default now lives in Settings › Valuation (FIG-322),
// and the On Order / Sold Payables columns wait on UC-222.

interface DrSkuDefaultNoteProps {
  drSkuPercentage: number | string | null | undefined;
  isReseller: boolean;
  onOpenSettings?: () => void;
}

export const DrSkuDefaultNote: React.FC<DrSkuDefaultNoteProps> = ({ drSkuPercentage, isReseller, onOpenSettings }) => {
  const value = Number(drSkuPercentage ?? 0);
  const percent = (Number.isFinite(value) ? value : 0).toLocaleString('en-US', { maximumFractionDigits: 2 });
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-muted-foreground">
      <span className="flex items-center gap-1" data-testid="dr-sku-default">
        <span>DR SKU: {percent}%</span>
        {onOpenSettings && (
          <>
            <span aria-hidden="true">·</span>
            <Button variant="link" size="sm" className="h-auto p-0" onClick={onOpenSettings}>
              Change in Settings
            </Button>
          </>
        )}
      </span>
      <span className="text-xs" title={notAvailableYetHint('UC-222')}>
        {isReseller ? 'On Order and Sold Payables columns' : 'Sold Payables column'}: not available yet
      </span>
    </div>
  );
};

export default DrSkuDefaultNote;
